
export function getServer() {
	//https://pdvlab.solide.app
	return 'https://pdvlab.solide.app';
};
